import * as Yup from 'yup';
import suscripcionesFormModel from './suscripcionesFormModel';

const {
    formField: {
        customerId,
        planId,
        startsAt,
        expiresAt,
        renewalType,
        monthlyCredits,
        nextRenewalAt,
        statusSuscription
    }
} = suscripcionesFormModel;

export default Yup.object().shape({
    [customerId.name]: Yup.mixed().required(customerId.requiredErrorMsg),
    [planId.name]: Yup.mixed().required(planId.requiredErrorMsg),
    [startsAt.name]: Yup.date().nullable().required(startsAt.requiredErrorMsg),
    [expiresAt.name]: Yup.date().nullable().required(expiresAt.requiredErrorMsg),
    [renewalType.name]: Yup.string().max(50).required(renewalType.requiredErrorMsg),
    [monthlyCredits.name]: Yup.number().min(0).optional().nullable(),
    [nextRenewalAt.name]: Yup.date().nullable().optional(),
    [statusSuscription.name]: Yup.mixed().required(statusSuscription.requiredErrorMsg),
});

